import { render, staticRenderFns } from "./AzureComponent.vue?vue&type=template&id=adeae582&scoped=true&"
import script from "./AzureComponent.vue?vue&type=script&lang=ts&"
export * from "./AzureComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AzureComponent.vue?vue&type=style&index=0&id=adeae582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adeae582",
  null
  
)

export default component.exports